import { agentDomain } from '@/environment';
import { EmbedMode, EmbedOrientation, EmbedPosition } from './types';

export interface IGenerateCodeParams {
    agentId?: string;
    clientKey?: string;
    position?: EmbedPosition;
    mode?: EmbedMode;
    orientation?: EmbedOrientation;
    version?: '1' | '2';
}

export function generateCode({
    agentId,
    clientKey,
    position = 'right',
    mode = 'fabio',
    orientation = 'horizontal',
    version = '1',
}: IGenerateCodeParams = {}) {
    let params: string[] = [
        `type="module"`,
        `src="${agentDomain}/v${version}/index.js"`,
        `data-mode="${mode}"`,
        `data-client-key="${clientKey}"`,
        `data-agent-id="${agentId}"`,
        'data-name="did-agent"',
        'data-monitor="true"',
    ];

    if (mode === 'full') {
        params.push('data-target-id="<PLACE_YOUR_DIV_ID_HERE>"');
    } else if (mode === 'fabio') {
        if (orientation) {
            params.push(`data-orientation="${orientation}"`);
        }

        if (position) {
            params.push(`data-position="${position}"`);
        }
    }

    return `<script ${params.join('\n      ')}>\n</script>`.trim();
}
